$(document).ready(function () {

	ub.richardson = {};
	ub.richardson.data = {};

});